/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AssignmentRule } from './AssignmentRule';
import {
    AssignmentRuleFromJSON,
    AssignmentRuleFromJSONTyped,
    AssignmentRuleToJSON,
    AssignmentRuleToJSONTyped,
} from './AssignmentRule';

/**
 * 
 * @export
 * @interface ListAssignmentRules200Response
 */
export interface ListAssignmentRules200Response {
    /**
     * 
     */
    data: Array<AssignmentRule>;
}

/**
 * Check if a given object implements the ListAssignmentRules200Response interface.
 */
export function instanceOfListAssignmentRules200Response(value: object): value is ListAssignmentRules200Response {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ListAssignmentRules200ResponseFromJSON(json: any): ListAssignmentRules200Response {
    return ListAssignmentRules200ResponseFromJSONTyped(json, false);
}

export function ListAssignmentRules200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListAssignmentRules200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(AssignmentRuleFromJSON)),
    };
}

export function ListAssignmentRules200ResponseToJSON(json: any): ListAssignmentRules200Response {
    return ListAssignmentRules200ResponseToJSONTyped(json, false);
}

export function ListAssignmentRules200ResponseToJSONTyped(value?: ListAssignmentRules200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(AssignmentRuleToJSON)),
    };
}

